module.exports = __webpack_public_path__ + "img/accessory_hat_08.3641b3bb.svg";